import { useMemo, useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import Radio from "@material-ui/core/Radio";
import moment from "moment";

import PricelistTableHelper from "Helpers/pricelistTable.helper";
import locale from "locale";

const OfferPriceTable = ({
  dates,
  reductionTables,
  legend,
  firstTableHeader
}) => {
  const [selectedValue, setSelectedValue] = useState("Default");
  const [num, setNum] = useState(0);

  let [datesArr, roomArr] = useMemo(
    () => PricelistTableHelper.prepareDatesAndRoomTypes(dates),
    [dates]
  );

  const columns = useMemo(
    () => PricelistTableHelper.prepareColumns(datesArr),
    [datesArr]
  );

  const rows = useMemo(
    () => PricelistTableHelper.prepareRows(roomArr, dates),
    [roomArr, dates]
  );

  const rowsForRender = PricelistTableHelper.prepareRowsForRender(
    datesArr,
    rows,
    num
  );

  const data = {
    columns,
    rows: rowsForRender
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    const reductionTable = reductionTables.find(
      (t) => t.title === event.target.value
    );
    reductionTable ? setNum(reductionTable.num) : setNum(0);
  };

  return (
    <div className="moz-p-offer__table">
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div>
          <Radio
            checked={selectedValue === "Default"}
            onChange={handleChange}
            value="Default"
            name="radio-button-demo"
            inputProps={{ "aria-label": "Default" }}
          />
          {firstTableHeader ? firstTableHeader : locale.OFFER.PRICE_PER_PERSON}
        </div>
        {reductionTables &&
          reductionTables.map((t) => (
            <div className="ml-md-4" key={t.title}>
              <Radio
                checked={selectedValue === `${t.title}`}
                onChange={handleChange}
                value={`${t.title}`}
                name="radio-button-demo"
                inputProps={{ "aria-label": `${t.title}` }}
              />
              {`${t.title} ${locale.OFFER.PER_PERSON}`}
            </div>
          ))}
      </div>
      <MDBTable responsive hover className="text-center">
        <thead>
          <tr>
            <th>{locale.OFFER.NUMBER_OF_NIGHTS}</th>
            {datesArr
              .sort((a, b) => {
                if (
                  moment(a.split("-")[0], "D.M.YYYY") >
                  moment(b.split("-")[0], "D.M.YYYY")
                ) {
                  return 1;
                } else {
                  return -1;
                }
              })
              .map((d, i) => (
                <th key={i}>
                  {Math.abs(
                    moment(d.split("-")[0], "D.M.YYYY").diff(
                      moment(d.split("-")[1], "D.M.YYYY"),
                      "days"
                    )
                  )}
                </th>
              ))}
          </tr>
        </thead>
        <MDBTableHead columns={data.columns} />
        <MDBTableBody rows={data.rows} />
      </MDBTable>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        {legend.map((l) => (
          <div key={l}>{l}</div>
        ))}
      </div>
    </div>
  );
};

export default OfferPriceTable;
